import React, { Dispatch, FC, memo, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import {
  SecondaryNavBarItems,
  SecondaryNavigationBarStyled,
  SecondaryNavItemStyled,
  SecondaryNavTitleStyled,
} from "./styles";

interface SecondaryLinkItemType {
  id: string;
  text: string;
  link: string;
}

const linksConfig: Array<SecondaryLinkItemType> = [
  {
    id: "vehicles",
    text: "Vehicles",
    link: "/vehicles",
  },
  {
    id: "vehicleTypes",
    text: "Vehicle Types",
    link: "/vehicletypes",
  },
  {
    id: "fleets",
    text: "Fleets",
    link: "/fleets",
  },
];

export const SecondaryNavBarAssets: FC<{
  isSecondaryNavAssetsShown: boolean;
  setIsSecondaryNavAssetsShown: Dispatch<SetStateAction<boolean>>;
}> = memo(({ isSecondaryNavAssetsShown, setIsSecondaryNavAssetsShown }) => {
  const { pathname } = useLocation();

  return (
    <SecondaryNavigationBarStyled
      isShown={isSecondaryNavAssetsShown}
      onMouseEnter={() => {
        setIsSecondaryNavAssetsShown(true);
      }}
      onMouseLeave={() => {
        setIsSecondaryNavAssetsShown(false);
      }}
    >
      <SecondaryNavBarItems>
        {linksConfig.map(({ id, link, text }) => (
          <SecondaryNavItemStyled
            key={id}
            to={link}
            $active={pathname === link}
            onClick={() => {
              setIsSecondaryNavAssetsShown(false);
            }}
          >
            <SecondaryNavTitleStyled>{text}</SecondaryNavTitleStyled>
          </SecondaryNavItemStyled>
        ))}
      </SecondaryNavBarItems>
    </SecondaryNavigationBarStyled>
  );
});
